import { create } from 'zustand';
import api from '../api/offlineClient';

function saveUser(user) {
  try { localStorage.setItem('sgv_user', JSON.stringify(user)); } catch {}
}
function loadUser() {
  try { const u = localStorage.getItem('sgv_user'); return u ? JSON.parse(u) : null; } catch { return null; }
}

const useAuthStore = create((set) => ({
  user:    loadUser(), // restore immediately from localStorage (no API wait)
  token:   localStorage.getItem('token'),
  loading: false,
  error:   null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const data = await api.post('/api/auth/login', { email, password });
      localStorage.setItem('token', data.token);
      saveUser(data.user);
      set({ user: data.user, token: data.token, loading: false });
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      return false;
    }
  },

  updateUser: (patch) => set(s => {
    const user = { ...s.user, ...patch };
    saveUser(user);
    return { user };
  }),

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('sgv_user');
    set({ user: null, token: null });
  },

  fetchMe: async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const data = await api.get('/api/auth/me');
      if (data?.user) {
        saveUser(data.user);
        set({ user: data.user });
      }
    } catch {
      // Network error: keep existing session — don't log out
      // 401 errors are already handled by the offlineClient interceptor (redirect to /login)
    }
  },
}));

export default useAuthStore;
